import React from 'react';
import { ReactComponent as Selected } from '../../../assets/icons/Radiobutton-s.svg';
import { ReactComponent as NotSelected } from '../../../assets/icons/Radiobutton-n.svg';
import TextInput from '../../BaseComponents/TextInput';
import '../CompleteProfileForm/FormQuestion.scss';

type Answer = 'yes' | 'no';

type Props = {
  title: string;
  answer: Answer | undefined;
  detail: string;
  detailPlaceholder?: string;
  answerError?: string;
  detailError?: string;
  onAnswerChange: (answer: Answer) => void;
  onDetailChange: (value: string) => void;
};

/** Yes/No + describe control matching onboarding YesNoDescribeQuestion (without Formik). */
const MedicalCardYesNoDescribe: React.FC<Props> = ({
  title,
  answer,
  detail,
  detailPlaceholder = 'If yes, please describe:',
  answerError,
  detailError,
  onAnswerChange,
  onDetailChange
}) => (
  <div className='form-question-container'>
    <div className='section-header'>{title} *</div>
    <div className='answers'>
      <div className='yes-no'>
        <div
          className={`answer yes ${answer === 'yes' ? 'answer-active' : ''}`}
          onClick={() => onAnswerChange('yes')}
        >
          Yes
          {answer === 'yes' ? <Selected /> : <NotSelected />}
        </div>
        <div
          className={`answer no ${answer === 'no' ? 'answer-active' : ''}`}
          onClick={() => onAnswerChange('no')}
        >
          No
          {answer === 'no' ? <Selected /> : <NotSelected />}
        </div>
      </div>
    </div>
    {answerError && <div className='error-message'>{answerError}</div>}
    {answer === 'yes' && (
      <div className='supplements-selection'>
        <TextInput
          title='If yes, please describe: *'
          name='yes_no_detail'
          placeholder={detailPlaceholder}
          type='text'
          value={detail}
          isError={!!detailError}
          errorMessage={detailError}
          onChange={(e) => onDetailChange(e.target.value)}
        />
      </div>
    )}
  </div>
);

export default MedicalCardYesNoDescribe;
